export const allLambdas = (
  departmentId,
  appId = "001",
  environmentId,
  accountNumber = "904433914959",
  regionCode
) => {
  return [
    {
      ResourceName: "UpdateEC2AccessPolicy",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:UpdateEC2AccessPolicy",
      Region: regionCode ? regionCode : "us-east-1",
      DepartmentId: departmentId,
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "UpdateEC2AccessPolicy",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber ? accountNumber : "904433914959",
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:UpdateEC2AccessPolicy",
    },
    {
      ResourceName: "Create-Snapshot-List",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:Create-Snapshot-List",
      Region: regionCode ? regionCode : "us-east-1",
      DepartmentId: departmentId,
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "Create-Snapshot-List",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber ? accountNumber : "904433914959",
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:Create-Snapshot-List",
    },
    {
      ResourceName: "Verify-Snapshots",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:Verify-Snapshots",
      Region: regionCode ? regionCode : "us-east-1",
      DepartmentId: departmentId,
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "Verify-Snapshots",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber ? accountNumber : "904433914959",
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:Verify-Snapshots",
    },
  ];
};
